export default "__VITE_ASSET__96f29a77__"